export interface MathJaxConfig {
    chtml?,
    options?,
    [key: string]: any;
}

declare let FilesFingerprint: any;

export default class MathJax {
    public src: string;
    protected publicDir : string = '/specs/products/acropolis/pericles/releasedAssets/public';
    public config : MathJaxConfig = {
            chtml: {
                 mathmlSpacing: true,
                 scale: 0.85 ,
                },
            options: {
             enableEnrichment: true,
             a11y: {
               speech: true,                      // switch on speech output
               braille: true
             },
             menuOptions: {
               settings: {
                 assistiveMml: true,   // true to enable assitive MathML
                 collapsible: false,   // true to enable collapsible math
                 explorer: true      // true to enable the expression explorer
               }
             }
           },
    }
    public startupConfig : any = `{
        pageReady: function () {
            return MathJax.startup.defaultPageReady().then(() => {
                document.dispatchEvent(new Event("mathjax-initilized"))
            });
          }
    }`
    
    elements = {
        searchResult: document.querySelector('#search-result'),
        head: document.head,
        mathJaxSrc: document.createElement('script'),
        mathJaxConfig: document.createElement('script'),
        mathJaxStartup: document.createElement('script'),
        versionFlag: document.querySelector('meta[name="mathjax-version"]')?.getAttribute('content'), // "3" | "4"
        lazyLoadFlag: document.querySelector('meta[name="mathjax-lazy-load"]')?.getAttribute('content'),  // "true" | "false"
        enableFlag:document.querySelector('meta[name="mathjax-enabled"]')?.getAttribute('content')  // "true" | "false"
    };

    private initilize = ()=>{
        try {
            if ((window as any).opera) {
                this.elements.mathJaxConfig.innerHTML = `window.MathJax = ${JSON.stringify(this.config)}`;
                this.elements.mathJaxStartup.innerHTML = `window.MathJax.startup = ${this.startupConfig}`
            } else {
                this.elements.mathJaxConfig.text = `window.MathJax = ${JSON.stringify(this.config)}`;
                this.elements.mathJaxStartup.text = `window.MathJax.startup = ${this.startupConfig}`
            }
            this.elements.head.appendChild(this.elements.mathJaxConfig);
            this.elements.head.appendChild(this.elements.mathJaxStartup);
            this.elements.mathJaxSrc.type = 'text/javascript';
            this.elements.mathJaxSrc.defer = true;
            this.elements.mathJaxSrc.src = this.src;
            this.elements.head.appendChild(this.elements.mathJaxSrc);
        } catch (error) {
            console.error("something went wrong when importing MathJax :", error)
        }
    }

    constructor() {
        if (this.elements.versionFlag === '4'){
            this.src =  `${this.publicDir}/mathjax4-${FilesFingerprint.mathjax4}/tex-mml-chtml.js` ;
            this.config = {
                ...this.config,
                chtml : {
                    ...this.config.chtml,
                    fontURL : `${this.publicDir}/mathjax-fonts-${FilesFingerprint.mathjaxFonts}`
                }
            }
        }
        else{
            this.src =  `${this.publicDir}/mathjax3-${FilesFingerprint.mathjax3}/es5/tex-mml-chtml.js`;
        }

        if(this.elements.lazyLoadFlag === "true" && this.elements.searchResult === null){
            this.config = {
                ...this.config,
                loader: { 
                    ...this.config.loader,
                    load: ['ui/lazy'] 
                },
              };              
        }
        if (this.elements.enableFlag === "true"){
            this.initilize();
        }
    } 
}